import MainLayout from "../layout/MainLayout";

const ErrorPage = () => {
    return <>NIE MA TAKIEJ STRONY</>;
}

export default ErrorPage;